// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xlVH","left":"styles_left__2BYje"};